module.exports = __webpack_public_path__ + "static/media/c29.680f1496.png";